import axios from 'axios';
import React, {Component} from 'react';
import md5 from 'md5';

export default class SessionHelper extends Component {
    static handleData(sessionData) {
        if (sessionData) {
            this.gotData = true;

            SessionHelper.sessionData = sessionData;

            if (SessionHelper.callbacks) {
                for (let i = 0; i < SessionHelper.callbacks.length; i++) {
                    SessionHelper.callbacks[i]();
                }
            }
        }
    }

    static get isLoggedIn() {
        return SessionHelper.sessionData && !!SessionHelper.sessionData.logged_in;
    }

    static get userName() {
        return (SessionHelper.isLoggedIn && SessionHelper.sessionData.name) || "Gebruiker";
    }

    static get userEmail() {
        return (SessionHelper.isLoggedIn && SessionHelper.sessionData.email) || "Onbekend";
    }

    static get userId() {
        return (SessionHelper.isLoggedIn && SessionHelper.sessionData.aid) || -1;
    }

    static get userAvatarUrl() {
        let hash = md5(this.userEmail || "default@rememberme.nl");
        return `https://www.gravatar.com/avatar/${hash}?s=256&d=mp`;
    }

    static fetch(force) {
        return new Promise((resolve, reject) => {
            if (SessionHelper.gotData && !force) {
                resolve(SessionHelper.sessionData);
                return;
            }

            this.refresh()
                .then(() => {
                    resolve(SessionHelper.sessionData);
                })
                .catch(() => {
                    reject();
                });
        });
    }

    static refresh() {
        return axios.get('/status')
            .then((res) => {
                this.handleData(res.data);
            })
            .catch((err) => {
                console.error('Session refresh/status GET, error caught:', err);
            });
    }

    static onChange(callback) {
        SessionHelper.callbacks.push(callback);
    }

    static removeOnChangeListener(callback) {
        let next = [];

        for (let i = 0; i < SessionHelper.callbacks.length; i++) {
            let _cb = SessionHelper.callbacks[i];

            if (_cb === callback) {
                continue;
            }

            next.push(_cb);
        }

        SessionHelper.callbacks = next;
    }

    componentDidMount() {
        this.interval = setInterval(() => {
            SessionHelper.refresh();
        }, SessionHelper.REFRESH_INTERVAL_MS);

        SessionHelper.refresh();
    }

    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    render() {
        return <div>{this.props.children}</div>;
    }
}

SessionHelper.gotData = false;

SessionHelper.callbacks = [];

SessionHelper.sessionData = {
    logged_in: false
};

SessionHelper.REFRESH_INTERVAL_MS = 1000 * 60 * 2;



// WEBPACK FOOTER //
// ./src/System/SessionHelper.js